module.exports = __webpack_public_path__ + "static/img/index.a9d605b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/other/QYM/index.png
// module id = Migz
// module chunks = 0